// extracted by mini-css-extract-plugin
export default {"footerBg":"u-z","footerTopLinks":"v-z","footerFeedback":"w-z","footerSocial":"x-z","footerLegalLinks":"y-z","footerIconCards":"z-z","footerBotCopy":"A-z"};